/* eslint-disable @angular-eslint/no-output-on-prefix */
import { Component, output, OutputEmitterRef } from "@angular/core";

@Component({
  selector: "cla-login-prompt",
  templateUrl: "./login-prompt.component.html",
  styleUrl: "./login-prompt.component.scss",
  standalone: false,
})
export class LoginPromptComponent {
  readonly onCredentialLogin: OutputEmitterRef<void> = output<void>();
  readonly onSsoLogin: OutputEmitterRef<void> = output<void>();
  readonly onMfaConfigure: OutputEmitterRef<void> = output<void>();

  credentialLoginSelected(): void {
    this.onCredentialLogin.emit();
  }

  ssoLoginSelected(): void {
    this.onSsoLogin.emit();
  }

  mfaConfigSelected(): void {
    this.onMfaConfigure.emit();
  }
}
